module.exports = __webpack_public_path__ + "assets/img/nodejs_lts.c1cf4990.jpg";